import { render } from "./LiquidationAttachments.vue?vue&type=template&id=00f13fd4"
import script from "./LiquidationAttachments.vue?vue&type=script&lang=js"
export * from "./LiquidationAttachments.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__